import { Box, Paper, Typography } from '@mui/material';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import { useTranslation } from 'react-i18next';
import { useNetworkStatus } from './NetworkStatusContext';

export function NetworkUnavailableOverlay() {
  const { status } = useNetworkStatus();
  const { t } = useTranslation('entity-portal');

  if (status !== 'unavailable') {
    return null;
  }

  return (
    <Box
      role="alert"
      aria-live="assertive"
      sx={{
        position: 'fixed',
        inset: 0,
        zIndex: (theme) => theme.zIndex.modal + 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'rgba(0, 0, 0, 0.72)',
        p: 2,
      }}
    >
      <Paper
        elevation={6}
        sx={{
          maxWidth: 480,
          p: 4,
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <WifiOffIcon color="error" sx={{ fontSize: 48 }} />
        <Typography variant="h6">
          {t('network.networkUnavailableTitle')}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {t('network.networkUnavailableMessage')}
        </Typography>
      </Paper>
    </Box>
  );
}
